const state = {
  snackbar: {
    message: '',
    type: 'success',
    timeout: 3000,
    canClose: true,
    value: false
  },
  darkMode: false,
  loading: {
    active: false,
    clickAble: true,
    message: 'This is message.'
  }
}

const actions = {
  setLoading ({ commit }, payload) {
    commit('SET_LOADING', payload)
  },
  setSnackbar ({ commit }, payload) {
    commit('SET_SNACKBAR', payload)
  },
  setDarkMode ({ commit }, payload) {
    commit('SET_DARKMODE', payload)
  }
}

const mutations = {
  SET_LOADING (state, payload) {
    state.loading.active = payload.active
    state.loading.clickAble = payload.clickAble
    state.loading.message = payload.message
  },
  SET_SNACKBAR (state, payload) {
    state.snackbar.message = payload.message || ''
    state.snackbar.type = payload.type || ''
    state.snackbar.value = payload.value || false
    state.snackbar.canClose = !!(payload.canClose === null || payload.canClose === undefined || payload.canClose === true)
    state.snackbar.timeout = payload.timeout || 3000
  },
  SET_DARKMODE (state, payload) {
    state.darkMode = payload
  }
}

const getters = {
  snackbar: (state) => state.snackbar,
  darkMode: (state) => state.darkMode,
  loading: (state) => state.loading
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
